var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditScenario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#1F36C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4282 7.55175L12.4482 9.57222L7.73387 14.286H5.71387V12.2656L10.4282 7.55127V7.55175ZM11.1015 6.87841L12.1115 5.86794C12.2008 5.77867 12.3219 5.72852 12.4482 5.72852C12.5744 5.72852 12.6955 5.77867 12.7848 5.86794L14.132 7.21508C14.2212 7.30438 14.2714 7.42548 14.2714 7.55175C14.2714 7.67802 14.2212 7.79911 14.132 7.88841L13.1215 8.89841L11.1015 6.87841Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditScenario);
export default __webpack_public_path__ + "static/media/edit-scenario.5df66209c5e0899ab497251b76d7b772.svg";
export { ForwardRef as ReactComponent };